<template>
  <v-container fluid>
    <validation-observer v-slot="{ invalid }">
      <v-row>
        <v-col cols="12" md="12">
          <v-row>
            <v-col cols="12" md="12">
              <basic-info-consultar-coge id="basic-info-consultar" ref="basicInfoConsultarCoge" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            color="green"
            min-width="100"
            style="float: right"
            class="mt-n5"
            :disabled="invalid"
            :loading="loading"
            @click="consultar()"
          >
            Consultar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import CogeService from '@/services/CogeService.js';

  export default {
    name: 'Coge',

    components: {
      BasicInfoConsultarCoge: () => import('@/components/coge/BasicInfoConsultarCoge')
    },

    data() {
      return {
        loading: false,
        codigosIsValid: false
      };
    },

    methods: {
      consultar() {
        this.loading = true;
        let objCodigosMcpse = {
          ...this.$refs.basicInfoConsultarCoge.exportData()
        };

        CogeService.consultar(objCodigosMcpse)
          .then((response) => {
            this.$toast.info('Preparando seu arquivo para download.', '', { position: 'topRight', timeout: 3000 });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            let nomeArquivo = this.getNomeArquivo();
            link.setAttribute('download', nomeArquivo);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.error(error.response);
            if (typeof error.response !== 'undefined') {
              this.$toast.error('Erro ao gerar arquivo xlsx com o resultado COGE.', '', { position: 'topRight' });
            }
          })
          .finally(() => (this.loading = false));
      },

      getNomeArquivo() {
        let nomeEmpresa = this.$store.getters.getSiglaEmpresa;
        return nomeEmpresa + '_consulta_coge.xlsx';
      }
    }
  };
</script>